import React from "react";
import { CpButton, CpRadio, CpInlineNotification } from "canopy-styleguide!sofe";
import { mfaTypeMap, mfaTypeMapWithSetup } from "./code-mfa.helpers";
import { useCss, k, a, m } from "kremling";
import { featureEnabled } from "feature-toggles!sofe";

export function MfaType(props) {
  const { routeToSignIn, mfaType, setMfaType, mfaTypes, mobile, onSetupMfa, navigate, sendVerificationCode } = props;
  const scope = useCss(css);

  const handleRadioChange = (id) => {
    const newType = mfaTypes.find((type) => type.id === id);
    setMfaType(newType);
  };

  const handleNext = () => {
    if (onSetupMfa) {
      if (mfaType.type === "sms") {
        navigate("setup-mfa-phone");
      } else {
        navigate("setup-mfa-auth");
      }
    } else {
      sendVerificationCode();
    }
  };

  return (
    <div {...scope}>
      {onSetupMfa ? (
        <div className="cp-mb-24">
          Your admin has updated the MFA settings for your firm. Select a new method below:
        </div>
      ) : (
        <>
          <div className="cp-mb-24">A one-time passcode will be sent to you as an additional verification step.</div>
          <div className="cp-mb-24 cp-wt-semibold">How do you want to get the code?</div>
        </>
      )}

      <CpRadio onChange={handleRadioChange} value={mfaType?.id} name="types">
        {mfaTypes?.map((type) => (
          <React.Fragment key={type.id}>
            <CpRadio.Item id={type.id} className="radio-list-item cp-caption">
              {onSetupMfa && featureEnabled("toggle_mfa")
                ? mfaTypeMapWithSetup[type.type]
                : `${mfaTypeMap[type.type]} ${type.display || ""}`}
            </CpRadio.Item>
            {type.type === "sms" && (
              <div className="sms-type-caption cp-caption">
                By continuing, you agree to receive text messages. Message and data rates may apply.
              </div>
            )}
          </React.Fragment>
        ))}
      </CpRadio>
      {featureEnabled("toggle_sms_reliability") && mfaType.type === "sms" && (
        <div className="cp-mt-16">
          <CpInlineNotification
            message="We've received reports of SMS delivery issues. If you experience problems, please try to authenticate using your email."
            type="error"
          />
        </div>
      )}
      <div className={a("cp-mt-40 cp-flex").m("mobile-button-group", mobile)}>
        <CpButton onClick={handleNext}>Next</CpButton>
        <CpButton btnType="secondary" onClick={routeToSignIn} className={m("cp-ml-16", !mobile)}>
          Back
        </CpButton>
      </div>
    </div>
  );
}

const css = k`
  .radio-list-item {
    overflow-wrap: anywhere;
    margin-bottom: 1.2rem;
  }

  .mobile-button-group {
    display: flex;
    flex-direction: column;
    height: 12.8rem;
    justify-content: space-between;
  }

  .sms-type-caption {
    margin-top: -0.4rem;
    margin-left: 2.4rem;
    color: var(--cp-color-app-secondary-text);
  }
`;
